var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaceSmile = function SvgFaceSmile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.496 14.996c.249.249.287.644.058.911A5.986 5.986 0 0 1 12 18a5.986 5.986 0 0 1-4.554-2.093c-.23-.267-.19-.662.058-.911.333-.333.89-.263 1.212.08A4.487 4.487 0 0 0 12 16.5a4.487 4.487 0 0 0 3.284-1.424c.322-.343.879-.413 1.212-.08ZM9.75 9.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM15.75 11.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 12c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12ZM21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  })));
};
export default SvgFaceSmile;